import { AiOutlineClose } from "react-icons/ai";
import {
  CancelBtn,
  MediumContainer,
  NextBtn,
} from "../../../screens/User/Users/components/IncidentType/incident.style";
import { useFormikContext } from "formik";
import { useIncidentFormContext } from "./IncidentContext";
import { useIncidentData } from "../../../layouts/incidentLayout";

interface IAskConfirmationProps {
  closeAskConfirmationModal: (x: boolean) => void;
}

const AskConfirmation = ({
  closeAskConfirmationModal,
}: IAskConfirmationProps) => {
  const formik = useFormikContext<{ [x: string]: any }>();

  const { setDeleteRLRecordObject } = useIncidentData();

  const { tempValue, setTempValue } = useIncidentFormContext();

  function handleModalClose() {
    closeAskConfirmationModal(false);
    setTempValue(undefined);
  }

  async function handleSetValue() {
    formik.setFieldValue(tempValue.fieldName, tempValue.value);
    let values = formik.values[tempValue.depField] ?? [];
    values = values
      .filter((value: any) => value.attributes?.type)
      .map((value: any) => {
        return {
          Sobject: value.attributes.type,
          Id: value.Id,
        };
      });

    setDeleteRLRecordObject(values);
    handleModalClose();
  }

  return (
    <MediumContainer>
      <div className="flex">
        <button
          onClick={handleModalClose}
          style={{
            fontSize: "30px",
            cursor: "pointer",
            border: "none",
            backgroundColor: "transparent",
          }}
        >
          <AiOutlineClose size={25} />
        </button>
      </div>
      <p className="text-md px-5 py-5 text-center">
        Are you sure you want to clear all records ?
      </p>

      <div className="mb-14 mr-7 mt-5">
        <NextBtn onClick={handleSetValue}>Clear</NextBtn>
        <CancelBtn onClick={handleModalClose}>Cancel</CancelBtn>
      </div>
    </MediumContainer>
  );
};

export default AskConfirmation;
